import type {SanctumUser, UserData} from '~/types/UserData';
import type {ComputedRef} from 'vue';

/**
 * Retourne l'utilisateur connecté de manière réactive.
 * Les changements effectués via le backend seront automatiquement reflétés.
 */
export const useAppUser = (): ComputedRef<UserData | null> => {
    const sanctumUser = useSanctumUser<SanctumUser | null>();

    return computed(() => sanctumUser.value?.data ?? null);
};
